import { Box, Flex } from '@chakra-ui/react';

import { Delete, Plus } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { Divider } from 'uiToolkitV1/Divider';
import { NumberInput } from 'uiToolkitV1/InputV2/NumberInput';
import { SelectDashed } from 'uiToolkitV1/Select';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const REMINDER_AUDIENCE = {
  REVIEWER: 'REVIEWER',
  MANAGER_SUMMARY: 'MANAGER_SUMMARY',
};

const REMINDER_AUDIENCE_LABELS = {
  REVIEWER: 'Send reminder to reviewer',
  MANAGER_SUMMARY: 'Send summary reminder to managers',
};

const RemindersSettings = ({ remindersSettings = [], onChange }) => {
  const handleChange = (valueAsNumber, index, key) => {
    const newRemindersSettings = remindersSettings.map((setting, i) => {
      if (i === index) {
        return { ...setting, [key]: valueAsNumber };
      }
      return setting;
    });
    onChange(newRemindersSettings);
  };

  const handleDelete = (index) => {
    const newRemindersSettings = remindersSettings.filter((_, i) => i !== index);
    onChange(newRemindersSettings);
  };

  const audienceOptions = [
    {
      label: REMINDER_AUDIENCE_LABELS[REMINDER_AUDIENCE.REVIEWER],
      value: REMINDER_AUDIENCE.REVIEWER,
    },
    {
      label: REMINDER_AUDIENCE_LABELS[REMINDER_AUDIENCE.MANAGER_SUMMARY],
      value: REMINDER_AUDIENCE.MANAGER_SUMMARY,
    },
  ];

  return (
    <>
      {remindersSettings.map(({ daysBeforeDeadline, audience }, i) => (
        <>
          <Flex key={i} p="8px 12px" alignItems="center" gap={2}>
            <Box cursor="pointer" tabIndex={0} onClick={() => handleDelete(i)} px={1}>
              <Delete color="text.g2" boxSize="24px" />
            </Box>
            <Box>
              <SelectDashed
                options={audienceOptions}
                value={audienceOptions.filter(({ value }) => value === audience)[0]}
                handleChange={({ value }) => handleChange(value, i, 'audience')}
                width="300px"
              />
            </Box>
            <Box width="50px">
              <NumberInput
                value={daysBeforeDeadline ?? ''}
                onChange={(valueAsString, valueAsNumber) => handleChange(valueAsNumber, i, 'daysBeforeDeadline')}
                min={0}
                type="number"
                clampValueOnBlur={false}
                inputMode="numeric"
                format={(val) => (Number.isNaN(val) ? '' : val)}
                max={100}
              />
            </Box>
            <TextBodyMedium>days before due date</TextBodyMedium>
          </Flex>
          {i < remindersSettings.length - 1 && <Divider />}
        </>
      ))}
    </>
  );
};

const Reminders = ({ remindersSettings, onChange }) => {
  const handleAdd = () => {
    const newRemindersSettings = [
      ...remindersSettings,
      { daysBeforeDeadline: 1, audience: REMINDER_AUDIENCE.REVIEWER },
    ];
    onChange(newRemindersSettings);
  };

  return (
    <Flex flexDirection="column" flexGrow={1}>
      {remindersSettings?.length > 0 && (
        <Flex
          bgColor="neutral.FDFDFD"
          borderRadius="8px"
          border="1px solid"
          borderColor="neutral.EBEFF3"
          flexDirection="column"
          mb={3}
          flexGrow={1}
        >
          <RemindersSettings remindersSettings={remindersSettings} onChange={onChange} />
        </Flex>
      )}
      <Button
        withBackground={false}
        alignSelf="flex-end"
        mb={2}
        mt={2}
        py="10px"
        variant="tertiary"
        StartIcon={() => <Plus boxSize="24px" />}
        onClick={handleAdd}
      >
        Add Reminder
      </Button>
    </Flex>
  );
};

export { Reminders };
